module.exports = __webpack_public_path__ + "img/symbol_10.3a84f697.png";